import React from 'react';

import { Box, Spinner } from '@rbilabs/universal-components';
import { StoreChangeDisclaimer } from 'features/store/pages/pickup-store-selector/components';

import ActionButton from 'components/action-button';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

import { DeliveryTerms } from '../delivery-terms';

import { ButtonContainer, DeliveryInfoContainer, LoadingText } from './styled';

interface IDeliveryFormFooterProps {
  submitAddress: () => void;
  isDisabled: boolean;
  isLoading: boolean;
  isEditing?: boolean;
  showtermsLink?: boolean;
}

export const DeliveryAddressFormFooter: React.FC<React.PropsWithChildren<
  IDeliveryFormFooterProps
>> = ({ submitAddress, isDisabled, isLoading, isEditing, showtermsLink }) => {
  return (
    <>
      {!showtermsLink ? (
        <ButtonContainer>
          <ActionButton
            onPress={submitAddress}
            fullWidth
            color={primitive.$white}
            mb="$4"
            disabled={isLoading || isDisabled}
            _disabled={{
              bg: primitive.$fieryRedOpacity30,
              color: primitive.$white,
              opacity: 1,
              borderWidth: 0,
            }}
            isLoading={isLoading}
            testID="deliver-here"
            rightIcon={
              isLoading ? (
                <Box width="$4" height="$4" justifyContent="center" alignItems="center">
                  <Spinner size="sm" color={primitive.$white} />
                </Box>
              ) : undefined
            }
            _text={{
              fontSize: 'lg',
              color: isLoading ? primitive.$bbqBrown : primitive.$white,
            }}
            _loading={{
              bg: primitive.$fieryRedOpacity30,
              borderWidth: 0,
              borderColor: primitive.$bbqBrown,
            }}
          >
            {isEditing ? t('upateAddress') : t('deliverHere')}
          </ActionButton>
        </ButtonContainer>
      ) : (
        <DeliveryInfoContainer>
          <DeliveryTerms />
          <StoreChangeDisclaimer />
        </DeliveryInfoContainer>
      )}
      {!isEditing && isLoading && (
        <Box>
          <LoadingText>{t('deliveryCheckingMessage')}</LoadingText>
        </Box>
      )}
    </>
  );
};
